export const WORKSPACE_AGENT_AUTOMATION_ROW_ID_ATTRIBUTE = 'data-workspace-agent-automation-row-id';
